@if ((cart$ | async); as cart) {
  <app-uig-vendor-order-summary [isCheckout]="true" class="wide"></app-uig-vendor-order-summary>
}
